import {TableSettings} from "../../../tableSettings";

export const receivingList:TableSettings = {
  tableVersion: 10056,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 35, canBeHidden: false, resizable: false, sortable: false },
    // 2023-10-19 jhchoi : Void 컬럼 제거(추후에 사용할 경우 주석 제거)
    // { accessor:'isVoid', Header: 'Void', visible: true, width: 35, canBeHidden: true, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    { accessor:'receiveNo', Header: 'Receiving ID', visible: true, width: 90, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'centerNo', Header: 'Customer', visible:true, width: 90, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'receiveDate', Header: 'In Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'orderDate', Header: 'Order Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'rcvStatus', Header: 'Status', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'p', Header: 'Paid', visible: true, width: 30, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'soNo', Header: 'S/O #', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vendor', Header: 'Ship From', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'trucker', Header: 'Carrier', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'palletRemark', Header: 'Pallet', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'remark', Header: 'Remark', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const shippingList:TableSettings = {
  tableVersion: 10055,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'sstatus', Header: 'S', visible: true, width: 35, canBeHidden: false, resizable: false, sortable: false, hiddenInColumnSetup: true },
    // 2023-10-19 jhchoi : Void 컬럼 제거(추후에 사용할 경우 주석 제거)
    // { accessor:'isVoid', Header: 'Void', visible: true, width: 35, canBeHidden: true, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    { accessor:'shipNo', Header: 'Shipping ID', visible: true, width: 90, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'centerNo', Header: 'Customer', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'shipDate', Header: 'Out Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'orderDate', Header: 'Order Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'status', Header: 'Sstatus', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'p', Header: 'Paid', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'poNo', Header: 'Order #', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'totalQty', Header: 'Total Qty', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'shipToNo', Header: 'Ship To', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'trucker', Header: 'Carrier', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'palletRemark', Header: 'Pallet', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'remark', Header: 'Remark', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const inOutList:TableSettings = {
  tableVersion: 10046,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'postDate', Header: 'Date', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'centerNo', Header: 'Customer', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'refNo', Header: 'Receiving/ShippingId', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'trucker', Header: 'Trucker', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'fromTo', Header: 'Ship From/To', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'itemNo', Header: 'Prod Code/SKU', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'location', Header: 'Location', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'poNo', Header: 'P.O #', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'qty', Header: 'Pack Qty', visible:true, width: 50, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'box', Header: 'Qty', visible:true, width: 50, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'boxUnit', Header: 'Unit', visible:true, width: 50, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'itemDesc', Header: 'Item Description', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lbs', Header: 'LBS', visible:true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'cft', Header: 'CFT', visible:true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'status', Header: 'Status', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'remark', Header: 'Remark', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const inventoryList:TableSettings = {
  tableVersion: 10047,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'centerNo', Header: 'Customer', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'itemNo', Header: 'Prod Code/SKU', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'itemDesc', Header: 'Description', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'upcCode', Header: 'UPC/EAN', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'onHandPcs', Header: 'On Hand Pack Qty', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'allPcs', Header: 'Allocated Pack Qty', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'availPcs', Header: 'Available Pack Qty', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'boxUnit', Header: 'Unit', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'innerPcs', Header: 'Inner Pack', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'onHandallQty', Header: 'On Hand Qty', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'allallQty', Header: 'Allocated Qty', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'availallQty', Header: 'Available Qty', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
  ]
};

export const invoiceList:TableSettings = {
  tableVersion: 1006,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'s', Header: 'S', visible: true, width: 35, canBeHidden: false, resizable: false, sortable: false, hiddenInColumnSetup: true },
    { accessor:'draft', Header: 'Draft', visible: true, width: 31, canBeHidden: false, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    // { accessor:'void', Header: 'Void', visible: true, width: 35, canBeHidden: false, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    { accessor:'invoiceDate', Header: 'Invoice Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'invoiceNo', Header: 'Invoice #', visible: true, width: 90, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'branch', Header: 'BR', visible:true, width: 26, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'invoiceTo', Header: 'Invoice To', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'customerRefNo', Header: 'Customer Ref. #', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'dueDate', Header: 'Due Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'overdue', Header: 'Overdue', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'cur', Header: 'CUR', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'amount', Header: 'Amount', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'paid', Header: 'Paid', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'balance', Header: 'Balance', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'lPaidCheckNo', Header: 'Paid Chk #', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lPaidDate', Header: 'Paid Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'clearDate', Header: 'Clear Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'faxDate', Header: 'Fax Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'emailDate', Header: 'Email Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'printDate', Header: 'Print Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'type', Header: 'Type', visible:true, width: 70, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'rId', Header: 'Receiving/Shipping ID', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const billList:TableSettings = {
  tableVersion: 1003,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'s', Header: 'S', visible: true, width: 35, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'draft', Header: 'Draft', visible: true, width: 31, canBeHidden: false, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    // { accessor:'void', Header: 'Void', visible: true, width: 35, canBeHidden: false, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    { accessor:'billDate', Header: 'Bill Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'billNo', Header: 'Bill #', visible: true, width: 90, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'branch', Header: 'BR', visible:true, width: 26, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vendor', Header: 'Vendor', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'dueDate', Header: 'Due Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'cur', Header: 'CUR', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'amount', Header: 'Amount', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'paid', Header: 'Paid', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'balance', Header: 'Balance', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'lPaidCheckNo', Header: 'Paid Chk #', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lPaidDate', Header: 'Paid Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'clearDate', Header: 'Chk Clear Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'rcvd', Header: 'B. Rcvd.', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'faxDate', Header: 'Fax Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'emailDate', Header: 'Email Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'printDate', Header: 'Print Date', visible:true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'type', Header: 'Type', visible:true, width: 70, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'rId', Header: 'Receiving/Shipping ID', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const storageInvoiceList:TableSettings = {
  tableVersion: 10012,
  verflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const companyList:TableSettings = {
  tableVersion: 10046,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'void', Header: 'Inactive', visible: true, width: 50, canBeHidden: false, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    { accessor:'type', Header: 'Type', visible: true, width: 50, canBeHidden: false, resizable: false, sortable: false, filterable: true, filterType: 'text' },
    { accessor:'companyId', Header: 'CompanyID', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'name', Header: 'CompanyName', visible:true, width: 250, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'phone', Header: 'Phone', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'fax', Header: 'fax', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'attention', Header: 'Attention', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'billGroup', Header: 'Bill Group', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'boxRate', Header: 'Box Rate', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'pcsRate', Header: 'Pcs Rate', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'cftRate', Header: 'CFT Rate', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'boxCharge', Header: 'Box Charge', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'labelCharge', Header: 'Label Charge', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'docCharge', Header: 'Doc Charge', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2Id', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1Id', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const itemList:TableSettings = {
  tableVersion: 10043,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'customer', Header: 'Company ID', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'prodCode', Header: 'Prod Code/SKU', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'itemDesc', Header: 'Description', visible: true, width: 95, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'upc', Header: 'UPC/EAN', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'boxUnit', Header: 'Unit', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'innerPac', Header: 'Inner Pack', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'defaultLoc', Header: 'Default Location', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lbs', Header: 'LBS', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'length', Header: 'Length', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'width', Header: 'Width', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'height', Header: 'Height', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'cft', Header: 'CFT', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const receiptList:TableSettings = {
  tableVersion: 10045,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'refNo', Header: 'Freight Receipt #', visible: true, width: 135, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'branch', Header: 'BR', visible: true, width: 35, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'receivedDate', Header: 'Receive Date', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'receivedBy', Header: 'Receive By', visible: true, width: 90, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'truckBLNo', Header: 'Truck B/L #', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'poNo', Header: 'P.O #', visible: true, width: 130, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'blNo', Header: 'B/L #', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'shipped', Header: 'Shipped', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'maker', Header: 'Maker', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sName', Header: 'Shipper', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sName1', Header: 'Consignee', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'commodity', Header: 'Commodity', visible:true, width: 124, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'amount', Header: 'Amount', visible:true, width: 142, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'hazGoods', Header: 'Hazardous', visible:true, width: 73, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const receiptContainerDetails:TableSettings = {
  tableVersion: 1006,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.73,
    },
    {
      Header: 'Length',
      accessor: 'length',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.84,
    },
    {
      Header: 'Width',
      accessor: 'width',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.84,
    },
    {
      Header: 'Height',
      accessor: 'height',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.84,
    },
    {
      Header: 'Packages',
      accessor: 'pcs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.84,
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.21,
    },
    {
      Header: 'LBS',
      accessor: 'dimKgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.70,
    },
    {
      Header: 'CBM',
      accessor: 'cbm',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.70,
    },
    {
      Header: 'Act. Weight',
      accessor: 'aWeight',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.95,
    },
    {
      Header: 'Shpd',
      accessor: 'shipped',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.84,
    },
    {
      Header: 'M',
      accessor: 'mode',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.73,
    },
    {
      Header: 'Date',
      accessor: 'shippedDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.57,
    },
    {
      Header: 'B/L #',
      accessor: 'blNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.69,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.48,
    },
  ]
};

export const shippingTopContainerDetails:TableSettings = {
  tableVersion: 10038,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '210px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.66,
    },
    {
      Header: 'Product Code/SKU',
      accessor: 'prodCode',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.20,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.63,
    },
    {
      Header: 'Inner Pack',
      accessor: 'pcsBox',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.32,
    },
    {
      Header: 'Pack Qty',
      accessor: 'packQty',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.32,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.32,
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.32,
    },
    {
      Header: 'LBS',
      accessor: 'lbs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.32,
    },
    {
      Header: 'CFT',
      accessor: 'cft',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.32,
    },
    {
      Header: 'Location',
      accessor: 'location',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.76,
    },
    {
      Header: 'Serial Number',
      accessor: 'serialNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.41,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.42,
    },
  ]
};

export const receivingTopContainerDetails:TableSettings = {
  tableVersion: 10046,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '210px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [ 
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.66, },
    { Header: 'Product Code/SKU', accessor: 'itemNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 12.20, },
    { Header: 'Description', accessor: 'itemDescription', resizable: false, sortable: false, visible: true, initialWidthPercentage: 10.98, },
    { Header: 'PO #', accessor: 'itemPoNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'Order Qty', accessor: 'ordQty', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'Inner Pack', accessor: 'pcsPerBox', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'Pack Qty', accessor: 'box', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'Qty', accessor: 'qty', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'Unit', accessor: 'boxUnit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'LBS', accessor: 'lbs', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'CFT', accessor: 'cft', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.32, },
    { Header: 'Location', accessor: 'location', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.54, },
    { Header: 'Reg', accessor: 'reg', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.66, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.40, },
  ]
};

export const receivingBottomContainerDetails:TableSettings = {
  tableVersion: 10046,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '210px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.67,
    },
    {
      Header: 'UPC Code',
      accessor: 'upcCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.78,
    },
    {
      Header: 'SKU #',
      accessor: 'skuNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.22,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.67,
    },
    {
      Header: 'Scanned Qty',
      accessor: 'scanQty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.22,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.44,
    },
  ]
};

export const sInvoiceLoadItem :TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  useStorage: true,
  flexResizer: true,

  alternateRows: false,
  headersColor: 'white',
  columns: [
    {
      Header: 'Select',
      accessor: 'select',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Billing Item',
      accessor: 'itemNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 40.27,
    },
    {
      Header: 'CUR',
      accessor: 'cur',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage:13.23,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage:13.23,
      maxWidth: 600,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.23,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.40,
    },
  ]
};

export const storageInvoiceLineItemTable:TableSettings = {
  tableVersion: 10049,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '210px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.57,
    },
    {
      Header: 'Billing Code',
      accessor: 'billingCodeView',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.19,
    },
    {
      Header: 'Billing Item',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 40.76,
    },
    {
      Header: 'CUR',
      accessor: 'cur',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.95,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.40,
    },
  ]
};

export const storageInvoiceLineItemTableWithVat:TableSettings = {
  tableVersion: 10003,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '210px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.57,
    },
    {
      Header: 'Billing Code',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.19,
    },
    {
      Header: 'Billing Item',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 37.74,
    },
    {
      Header: 'CUR',
      accessor: 'cur',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.95,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    { 
      Header: 'VAT', 
      accessor: 'useVat', 
      resizable: true, 
      sortable: false, 
      visible: true, 
      initialWidthPercentage: 3.02, 
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.40,
    },
  ]
};

export const storageInvoiceBottomContainerDetails:TableSettings = {
  overflowX: 'hidden',
  overflowY: 'scroll',
  // 
  height: '210px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.28,
    },
    {
      Header: 'Inv Seq',
      accessor: 'invoiceSeq',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.85,
    },
    {
      Header: 'Customer',
      accessor: 'companyName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 50.37,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25.18,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.28,
    },
  ]
};

export const locationList:TableSettings = {
  tableVersion: 10043,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor: 'indicator', Header: '', visible:true, width: 30, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor: 'location', Header: 'Location', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor: 'zone', Header: 'Zone', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor: 'row', Header: 'Row', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor: 'level', Header: 'Level', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor: 'storage', Header: 'Occupied', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'bool', },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create By', visible: true, width: 88, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },]
};

/*More button popups*/
export const batchPrintTable:TableSettings = {
  tableVersion: 1002,
  overflowX: 'hidden',
  overflowY: 'auto',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'Invoice #',
      accessor: 'invoiceNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Date',
      accessor: 'date',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Bill To',
      accessor: 'billTo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: 'Sales',
      accessor: 'sales',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Fax',
      accessor: 'fax',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
  ]
};

export const receivingShippingChargeItemDetails:TableSettings = {
  tableVersion: 10051,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '210px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Billing Code',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 21.00,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25.00,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.00,
    },
    {
      Header: 'Count',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.00,
    },
    {
      Header: 'Billing #',
      accessor: 'invoiceNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.00,
    },
    {
      Header: 'Draft',
      accessor: 'isDraft',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.00,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.00,
    },
  ]
};
